import { useEffect, useState, useContext } from "react";
import { Column, Icon, Panel, Row, Button, Select, RichTextQuill } from "../../../components";
import { Container, Badge, Form, FloatingLabel } from "react-bootstrap";
import React from "react";
import { FaChevronRight, FaChevronDown } from 'react-icons/fa';
import * as constant from '../../../shared/util/constant';
import { CommonUtility } from '../../../Services/CommonUtility';
import insuranceProducts from '../../../shared/components/insuranceProductList/InsuranceProductList.json';
import { policyTypeIconMapping } from '../../../shared/components/insuranceProductList/InsuranceProductListService';
import * as label from '../../../shared/util/label';
import moment from 'moment';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useDispatch, useSelector } from "react-redux";
import CustomerDocumentService from "../../customer-document/CustomerDocumentService";
import classNames from "classnames";
import './SliderEmailDocument.scss'
import * as docuMateConstant from '../../../DocuMate/shared/util/docuMateConstant';
import TextInputWithLabelFormGroup from "../../../shared/components/input/TextInputWithLabelFormGroup";
import SliderEmailDocumentService from "./SliderEmailDocumentService";
import SendDocumentByEmailQuery from "../../model/EmailDocumentModel/SendDocumentByEmailQuery";
import SendDocumentByEmailRequestDto from "../../model/EmailDocumentModel/SendDocumentByEmailRequestDto";
import { toast } from "react-toastify";
import CustomerActivityService from "../../customer-activity/CustomerActivityService";
import { CustomerActivityAddRequest } from "../../model/CustomerActivityAddRequest";
import { notifyAppEvent, AppEvenType } from "../../../shared/store/component-notification/ComponentNotification";

export interface ISliderEmailDocument {
    customerId?: string,
}

const SliderEmailDocument: React.FunctionComponent<ISliderEmailDocument> = (props) => {
    const customerId = props.customerId;
    const [custNumber, setCustNumber] = useState('');
    const [custName, setCustName] = useState('');    
    const customerSummary = useSelector((state: any) => state.customerSlice);
    const dispatch = useDispatch();
    const [docWithPolicies, setDocWithPolicies] = useState([]);
    const [docWithOutPolicies, setDocWithOutPolicies] = useState([]);
    const [expandedTerm, setExpandedTerm] = useState<string | null>(null);
    const [screenMessage, setScreenMessage] = useState("No documents available");
    const [recipients, setRecipients] = useState('');
    const [recipientsError, setRecipientsError] = useState('');
    const [subject, setSubject] = useState('');
    const [emailBody, setEmailBody] = useState('');    
    const customerDocumentService = new CustomerDocumentService();
    const customerActivityService = new CustomerActivityService();
    const [formValidationForEmailDocPage, setFormValidationForEmailDocPage] = useState<any>({});
    const [emailOutActivityTypeId, setEmailOutActivityTypeId] = useState<string | undefined>(undefined);

    useEffect(() => {
            setCustNumber(customerSummary.customerSummary?.custNumber || '');
            setCustName(customerSummary.customerSummary?.displayName || '');
            getCustomerPolicyTermDocumentDetails();
        }, [customerId]);

    useEffect(() => {
        customerActivityService.getActivityTypes().then(activityTypes => {
            const emailOutType = activityTypes.find(
                t => t.label?.toLowerCase() === constant.EmailDocuments.EMAIL_OUT_ACTIVITY_TYPE.toLowerCase()
            );
            if (emailOutType) {
                setEmailOutActivityTypeId(emailOutType.value);
            }
        });
    }, []);

    const getCustomerPolicyTermDocumentDetails = async () => {        
            const customerPolicyTermDocumentDetails = await customerDocumentService.getCustomerPolicyTermDocumentDetails(customerId);
            
            let CustNumber = '';
            let CustName = '';
            const documentsWithoutPolicyNumber = customerPolicyTermDocumentDetails
                .filter(policy => policy.policyNumber === null)
                .reduce((acc, policy) => {
                    policy.documents.forEach(doc => {
                        const folderPath = splitFolders(doc.attributeValue || '');
                        const isOneStep = folderPath.includes(docuMateConstant.NoPolicyFolderName);
    
                        // Find or create the correct group
                        const type = isOneStep ? docuMateConstant.NoPolicyFolderName : "OTHER";
                        let group = acc.find(p => p.type === type);
                        if (!group) {
                            group = {
                                type,
                                custId: policy.custId,
                                custNumber: policy.custNumber,
                                custName: policy.custName,
                                folders: []
                            };
                            acc.push(group);
                        }
                        addDocumentToNoPolicyNumberGroup(group, folderPath, doc);
                    });
    
                    if (acc.length === 0) {
                        CustNumber = policy.custNumber;
                        CustName = policy.custName;
                    }
                    return acc;
                }, []);

             
    
            const documentsWithPolicyNumber = customerPolicyTermDocumentDetails
                .filter(policy => policy.policyNumber !== null)
                .reduce((acc, policy) => {
                    let group = acc.find(p => p.policyNumber === policy.policyNumber);
                    if (!group) {
                        group = {
                            custId: policy.custId,
                            custNumber: policy.custNumber,
                            custName: policy.custName,
                            policyNumber: policy.policyNumber,
                            policyType: policy.policyType,
                            policyTypeId: policy.policyTypeId,
                            terms: []
                        };
                        acc.push(group);
                    }
                    group.terms.push({
                        id: policy.policyId,
                        polEffDate: policy.polEffDate,
                        polExpDate: policy.polExpDate,
                        policyStatus: policy.policyTermStatus,
                        calculatedPolTermStatus: policy.calculatedPolTermStatus,
                        isUnknown: policy.documents.some(doc => 
                            (policy.polExpDate || '').trim() !== (doc.attributeValue.split(" to ")[1] || '').trim()
                        ),
                        documents: policy.documents
                    });
                    if (acc.length === 0) {
                        CustNumber = policy.custNumber;
                        CustName = policy.custName;
                    }
                    return acc;
                }, []);             
    
            if (documentsWithPolicyNumber.length > 0) {
                setDocWithPolicies(documentsWithPolicyNumber);
            }
            else {
                setDocWithPolicies([]);
            }
    
            if (documentsWithoutPolicyNumber.length > 0) {
                setDocWithOutPolicies(documentsWithoutPolicyNumber);
            }
            else {
                setDocWithOutPolicies([]);
            }
    
            if (documentsWithoutPolicyNumber.length == 0 && documentsWithPolicyNumber.length == 0) {
                setScreenMessage('Documents are not available for this customer.');
            }
          // Call the function to sort the array
           sortDocumentsWithPolicyNumber(documentsWithPolicyNumber);
        };

    const addDocumentToNoPolicyNumberGroup = (group, folderPath, doc) => {
                let currentLevel = group.folders;            
                folderPath.forEach((folder, index) => {
                    let existing = currentLevel.find(item => item.name === folder);
                    if (!existing) {
                        existing = { name: folder, children: [] };
                        currentLevel.push(existing);
                    }
                    if (index === folderPath.length - 1) {
                        if (!existing.documents) existing.documents = [];
                        existing.documents.push(doc);
                    } else {
                        currentLevel = existing.children;
                    }
                });
            };
    
    
        const sortDocumentsWithPolicyNumber = (documentsWithPolicyNumber: any[]) => {
            const statusOrder = constant.policyStatusOnDocumentTab;
            const policyTypeOrder = constant.policyTypeOrderOnDocumentTab;
            const sortedDocuments = [...documentsWithPolicyNumber];
            sortedDocuments.sort((a, b) => {
                // Sort by policyTermStatus
                const statusA = a.terms[0]?.policyStatus || "";
                const statusB = b.terms[0]?.policyStatus || "";
                const indexA = statusOrder.indexOf(statusA);
                const indexB = statusOrder.indexOf(statusB);
    
                // If the status is not found in `statusOrder`, assign it a high index to place it at the end
                const statusComparison = (indexA === -1 ? statusOrder.length : indexA) - (indexB === -1 ? statusOrder.length : indexB);
    
                // If the statuses are different, return the comparison result to sort by status
                if (statusComparison !== 0) {
                    return statusComparison;
                }
    
                // If policyTermStatus is the same, sort by policyTypeId
                const typeA = policyTypeOrder[a.policyTypeId] || 10;
                const typeB = policyTypeOrder[b.policyTypeId] || 10;
                return typeA - typeB;
            });
    
               // Sort terms in descending order by `polEffDate` under each policy group        
                sortedDocuments.forEach(policy => {
                    policy.terms.sort((termA, termB) => {
                        const dateA = new Date(termA.polEffDate).getTime();
                        const dateB = new Date(termB.polEffDate).getTime();
                        return dateB - dateA; // Descending order
                    });
                });
    
            if (sortedDocuments.length > 0) {
                setDocWithPolicies(sortedDocuments);
            }
            else {
                setDocWithPolicies([]);
            }
        };

    const [expandedFolders, setExpandedFolders] = useState([]);
        const toggleFolder = (folderPath: string) => {
            setExpandedFolders((prev) =>
                prev.includes(folderPath) ? prev.filter((path) => path !== folderPath)
                    : [...prev, folderPath]
            );
        };    
    
    const splitFolders = (attributeValue) => {
            if (!attributeValue) return [];
            const parts = attributeValue.split('/Policy').map((part, index) => {
                if (index === 0) return part.trim(); // First part before any 'Policy'
                return `Policy${part.trim() ? ' ' + part.trim() : ''}`; // Add 'Policy' back
            });
            return parts.filter(Boolean);
        };

    const getStatusBadgeClass = (status: string) => {
            const normalized = (status || 'Default').replaceAll(' ', '').replaceAll('-', '').toLowerCase();
            return `customerdoc-policy-status-badge customerdoc-policy-status-badge--${normalized}`;
        };
    
        const handleTermToggle = (termId: string) => {
            setExpandedTerm(expandedTerm === termId ? null : termId);
        };
    
        const getPolicyIcon = (policyTypeId: string) => {
            if (!policyTypeId) return 'circle-question';
            const iconId = policyTypeIconMapping[policyTypeId];
            const product = insuranceProducts.find((item) => item.id === iconId);
            return product?.icon || 'circle-question';
        };
    const [selectedDocIds, setSelectedDocIds] = useState<string[]>([]);
    const [selectedTermId, setSelectedTermId] = useState<string | null>(null);
    
    const onClearClick = () => {
        setSelectedDocIds([]);
        setSelectedTermId(null);
        setRecipients('');
        setSubject('');
        setEmailBody('');
        setFormValidationForEmailDocPage({});
        setRecipientsError('');
        setExpandedTerm(null); 
        setExpandedFolders([]);
    };

    const handleDocSelect = (docId: string, termId: string) => {
        // If clicking a document from a different term, clear previous selections
        if (selectedTermId && selectedTermId !== termId) {
            setSelectedDocIds([docId]);
            setSelectedTermId(termId);
        } else {
            // Same term - toggle selection
            setSelectedDocIds(prev =>
                prev.includes(docId)
                    ? prev.filter(id => id !== docId)
                    : [...prev, docId]
            );
            setSelectedTermId(termId);
        }
    };   
    
    const validateEmails = (emails: string) => {
        if (!emails.trim()) return true;
        const emailList = emails.split(';').map(e => e.trim()).filter(Boolean);
        return emailList.every(email => CommonUtility.isEmailValid(email));
    };

    const handleRecipientsChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const value = e.target.value;
        setRecipients(value);
        if (!validateEmails(value)) {
            setRecipientsError(constant.SEND_TEST_INVALID_EMAIL_FORMAT_WARNING);
        } else {
            setRecipientsError('');
        }
    };

    const getSelectedPolicyId = (): string | undefined => {
        if (!selectedTermId) return undefined;
        for (const policy of (docWithPolicies as any[])) {
            for (const term of policy.terms) {
                if (term.id === selectedTermId) {
                    return term.id;
                }
            }
        }
        return undefined;
    };

    const handleSendEmail = async() => {
        const sliderEmailDocObj = new SliderEmailDocumentService();
        let validationError = sliderEmailDocObj.validateEmailDoc(selectedDocIds, recipients, subject, emailBody);
        setFormValidationForEmailDocPage(validationError);
        if (Object.keys(validationError).length > 0) {
            toast.warning(constant.EmailDocuments.FORM_VALIDATION_ERROR_MESSAGE)
            return false;
        }
        
        setFormValidationForEmailDocPage({});

        let dtoRequest : SendDocumentByEmailQuery = {};  
        dtoRequest.emailBody = emailBody;
        dtoRequest.emailSubject = subject;
        dtoRequest.emailTo = recipients;
        dtoRequest.documentList = selectedDocIds.map(docId => {
            let docDto: SendDocumentByEmailRequestDto = {};
            docDto.docFileId = docId;
            return docDto;
        });
        
        const emailDocResponse =  await sliderEmailDocObj.sendEmailDocuments(dtoRequest);
        if(emailDocResponse !==null && emailDocResponse.isDocumentBlobError === false && emailDocResponse.isEmailSendError === false)
        {
            toast.success(constant.EmailDocuments.EMAIL_SENT_SUCCESS);

            try {
                const policyId = getSelectedPolicyId();
                const activityRequest: CustomerActivityAddRequest = {
                    custId: customerId,
                    activityTypeId: emailOutActivityTypeId,
                    tranTypeId: undefined,
                    policyId: policyId,
                    activityEffDate: new Date(),
                    description: subject,
                    claimId: undefined,
                };
                const createdActivity = await customerActivityService.addNewActivity(activityRequest);
                if (createdActivity) {
                    dispatch(notifyAppEvent({ eventType: AppEvenType.NewCustomerActivityCreated, eventData: createdActivity }));
                }
            } catch {
                toast.warn(constant.EmailDocuments.ACTIVITY_CREATE_ERROR);
            }

            onClearClick();
        }
        else
        {
            toast.error(constant.EmailDocuments.EMAIL_FAILURE);
        }

        return emailDocResponse;
    };

   const renderPoliciesPanel = (policies) => (
         <div>
             {(
                 policies.map(policy => (
                     <div key={policy.policyNumber}>
                         <div className="policiesList policy-row policy-summary-header d-flex align-items-center justify-content-between">
                             <div className="d-flex align-items-center">
                                 <span className="cust-doc-policyicon">
                                     <FontAwesomeIcon icon={getPolicyIcon(policy.policyTypeId)} className='custdocpolicyIcons' />
                                 </span>
                                 <span className="policy-label">
                                     <span className="policy-highlight">
                                         {`${policy.policyNumber} ${policy.policyType || ''}`}
                                     </span>
                                 </span>
                             </div>
                             {policy.terms[0] && (
                                  <Badge className={ getStatusBadgeClass(policy.terms[0].calculatedPolTermStatus)  }>
                                     {policy.terms[0].policyStatus}
                                 </Badge>
 
                             )}
                         </div>
                         {policy.terms.map(term => (
                             <div key={term.id} className="cust-doc-termmargin">
                                 <div
                                     onClick={() => handleTermToggle(term.id)}
                                     className={classNames('termsList-container', 'term-row', expandedTerm === term.id ? 'selectedTerm' : '', 'slider-emaildocument-toggle-row')}
                                 >
                                     <span className="slider-emaildocument-toggle-icon">
                                         {expandedTerm === term.id ? <FaChevronDown /> : <FaChevronRight />}
                                     </span>
                                     <span className="slider-emaildocument-toggle-label">
                                        {term.isUnknown?  (
                                            <span>
                                                Term: Unknown
                                            </span>
                                        ) : (
                                            <span>
                                                Term: {term.polEffDate} - {term.polExpDate}
                                            </span>
                                        )}
                                    </span>
                                         
                                 </div>
                                 {expandedTerm === term.id && (
                                     <div className="cust-doc-term-extended">
                                         {term.documents && term.documents.length > 0 ? (
                                             term.documents.map((doc, idx) => (
                                                 <div 
                                                     key={doc.docFileId || idx} 
                                                     className={classNames("cust-doc-row", {
                                                         "selected-doc": selectedDocIds.includes(doc.docFileId)
                                                     }, 'slider-emaildocument-doc-row')}
                                                     onClick={() => handleDocSelect(doc.docFileId, term.id)}
                                                 >
                                                     <div className="cust-doc-column cust-doc-name">
                                                         <span className="policydoc-icon">
                                                             <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                                                         </span>
                                                         <strong className="cust-doc-name-truncate" title={doc.documentName}>
                                                             {doc.documentName}
                                                         </strong>
                                                     </div>
 
                                                     <div className="cust-doc-column cust-doc-type">
                                                         <span className="cust-doc-type-sec">{doc.documentType}</span>
                                                     </div>                                                    
                                                     <div className="cust-doc-column cust-doc-user-date">
                                                         {doc.docUser && (
                                                             <div className="cust-doc-date-sec">
                                                                 <strong>{'@' + doc.docUser + ' '}</strong>
                                                                 <span className="cust-doc-date">
                                                                     {doc.docDate && <strong>{moment(doc.docDate).format("MM/DD/YYYY")}</strong>}
                                                                 </span>
                                                             </div>
                                                         )}
                                                     </div>                                                     
                                                 </div>
                                             ))
                                         ) : (
                                             <span style={{ color: '#888' }}>No documents</span>
                                         )}
                                     </div>
                                 )}
                             </div>
                         ))}
                     </div>
                 ))
             )}
         </div>
     );

    // Update renderNestedFolders for non-policy docs
    const renderNestedFolders = (folders, level = 0, path = '', expandedFolders, toggleFolder) => {
            return folders.map((term, index) => {            
                const currentPath = path ? `${path}/${term.name}` : term.name;
                const isExpanded = Array.isArray(expandedFolders) && expandedFolders.includes(currentPath);
    
                return (
                    <div key={currentPath} className={classNames('slider-emaildocument-folder-row', `slider-emaildocument-folder-level-${level}`)}>
                        <div
                            onClick={() => toggleFolder(currentPath)}
                            className={classNames('termsList-container', 'term-row', isExpanded ? 'selectedTerm' : '', 'slider-emaildocument-toggle-row')}
                        >
                            <span className="slider-emaildocument-toggle-icon">
                                {isExpanded ? <FaChevronDown /> : <FaChevronRight />}
                            </span>
                            <span className="slider-emaildocument-toggle-label">{term.name}</span>
                        </div>
    
                        {isExpanded && (
                            <div className={classNames('slider-emaildocument-folder-content', `slider-emaildocument-folder-content-level-${level}`)}>
                                {term.documents && term.documents.map((doc, docIndex) => (
                                    <div 
                                        key={doc.docFileId || docIndex} 
                                        className={classNames("cust-doc-row", {
                                            "selected-doc": selectedDocIds.includes(doc.docFileId)
                                        }, 'slider-emaildocument-doc-row')}
                                        onClick={() => handleDocSelect(doc.docFileId, currentPath)}
                                    >
                                        <div className="cust-doc-column cust-doc-name">
                                                            <span className="policydoc-icon">
                                                                <FontAwesomeIcon icon={['fas', 'file-pdf']} />
                                                            </span>
                                                            <strong className="cust-doc-name-truncate" title={doc.documentName}>
                                                                {doc.documentName}
                                                            </strong>
                                        </div>
                                        <div className="cust-doc-column cust-doc-type">
                                                            <span className="cust-doc-type-sec">{doc.documentType}</span>
                                        </div>  
                                        <div className="cust-doc-column cust-doc-user-date">
                                                            {doc.docUser && (
                                                                <div className="cust-doc-date-sec">
                                                                    <strong>{'@' + doc.docUser + ' '}</strong>
                                                                    <span className="cust-doc-date">
                                                                        {doc.docDate && <strong>{moment(doc.docDate).format("MM/DD/YYYY")}</strong>}
                                                                    </span>
                                                                </div>
                                                            )}
                                         </div>                                        
                                    </div>
                                ))}
    
                                {term.children && term.children.length > 0 &&
                                    renderNestedFolders(term.children, level + 1, currentPath, expandedFolders, toggleFolder)
                                }
                            </div>
                        )}
                    </div>
                );
            });
        };
    
        const renderdocumentsWithoutPolicyNumber = (policies) => (
        <div>
            {policies.map((policy, index) => {          
                return (
                    <div key={index}>
                        
                        {renderNestedFolders(policy.folders, 0, '', expandedFolders, toggleFolder)}
                    </div>
                );        
            })}
        </div>
    );

    let mainContent = <>
        <Row>
            <Column lg={12} md={12} className="slider-emaildocument-header">
                <span className="sld-task-section-header">{label.CustomerSendDocViaEmailLabel.SEND_DOC}</span>
            </Column>
        </Row>

            <Row>
                <Column lg={12} md={12} className="col-section-header">
                <Panel className="emaildoc-panel-overflow-scroll">
                    <div className="emaildoc-panel-div1">
                    {(docWithPolicies.length === 0 && docWithOutPolicies.length === 0) ? (
                        <div className="message-container">{screenMessage}</div>
                    ) : (
                        <div className="emaildoc-panel-div2">
                            {docWithPolicies.length > 0 && (
                                <div>{renderPoliciesPanel(docWithPolicies)}</div>
                            )}
                        {[docuMateConstant.NoPolicyFolderName, "OTHER"].map(type => {
                                const filtered = docWithOutPolicies.filter(p => p.type === type);
                                if (filtered.length === 0) return null;

                                const displayName = type === docuMateConstant.NoPolicyFolderName 
                                    ? docuMateConstant.NoPolicyFolderName 
                                    : "Migrated Documents";

                                return (
                                    <div key={type}>
                                        <div className="policiesList policy-row policy-summary-header d-flex align-items-center justify-content-between">
                                            <div className="d-flex align-items-center">
                                                <span className="cust-doc-policyicon">
                                                    <Icon icon="folderOpen" className='custdocIcons' />
                                                </span>
                                                <span className="policy-label">
                                                    <span className="policy-highlight">
                                                        {displayName}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                        {renderdocumentsWithoutPolicyNumber(filtered)}
                                    </div>
                                );
                            })}
                        </div>
                    )}
                    </div>
                </Panel>
            </Column>            
         </Row>
         <Row className="slider-emaildocument-warning-row">
              {formValidationForEmailDocPage['selectedDocs']?.isValid == false && (
                    <Form.Control.Feedback type="invalid">
                        {formValidationForEmailDocPage['selectedDocs']?.warningText}
                    </Form.Control.Feedback>
                )}
         </Row>
        

            <Row>
                <Column lg={12} md={12} className="slider-emaildocument-recipients">
                <span className="sld-task-section-header">{'Recipients'}</span>
                <FloatingLabel
                        controlId="recipient"
                        label={
                            <>
                                {label.CustomerSendDocViaEmailLabel.RECEPIENT}
                                <span className="text-danger"> *</span>
                            </>
                        }
                    >
                <Form.Control
                    as="textarea"
                    rows={2}
                    name="recipient"
                    placeholder={label.CustomerSendDocViaEmailLabel.RECEPIENT}
                    value={recipients}
                    onChange={handleRecipientsChange}
                    isInvalid={!!recipientsError}
                />
                {recipientsError && (
                    <div className="enteremail-textbox-error">
                        {constant.SEND_TEST_INVALID_EMAIL_FORMAT_WARNING}
                    </div>
                )}
                {formValidationForEmailDocPage['recipient']?.isValid == false && (
                    <Form.Control.Feedback type="invalid">
                        {formValidationForEmailDocPage['recipient']?.warningText}
                    </Form.Control.Feedback>
                )}
            </FloatingLabel>           
            </Column>
        </Row>
        
        <Row>
            <Column lg={12} md={12} className="slider-emaildocument-details">
                <span className="sld-task-section-header">{'Email Details'}</span>
              
            <FloatingLabel
                        controlId="subject"
                        label={
                            <>
                                {label.CustomerSendDocViaEmailLabel.SUBJECT_LINE}
                                <span className="text-danger"> *</span>
                            </>
                        }
                    >
                <Form.Control
                    type="text"
                    name="subject"
                    placeholder={label.CustomerSendDocViaEmailLabel.SUBJECT_LINE}
                    value={subject}
                    style={{marginBottom: '5px' }}
                    onChange={(e) => setSubject(e.target.value)}
                />
                    {formValidationForEmailDocPage['subject']?.isValid == false && (
                    <Form.Control.Feedback type="invalid">
                        {formValidationForEmailDocPage['subject']?.warningText}
                    </Form.Control.Feedback>
                )}
            </FloatingLabel>

            <div>
                <RichTextQuill
                    id="body"
                    value={emailBody}
                    height={200}
                    onChange={(content) => setEmailBody(content as any)}
                />
                {formValidationForEmailDocPage['body']?.isValid == false && (
                    <div className="invalid-feedback d-block">
                        {formValidationForEmailDocPage['body']?.warningText}
                    </div>
                )}
            </div>
            </Column>
        </Row>

        <Row>
            <Column lg={12} md={12} className="slider-emaildocument-actions">
                <div className="slider-emaildocument-actions-row">
                    <Button
                                        className='btn btn-outline-tertiary sld-action-btn-base'
                                        key="btnActivityCancel"
                                        onClick={() => onClearClick()}
                                        id="btnEmailDocCancel"
                                        color='primary'
                                        outlined={true}
                                    >{label.StandardSearchLable.CLEAR.toLocaleUpperCase()}
                                    </Button>
                    <Button onClick={handleSendEmail}>
                        Send Email
                    </Button>
                </div>
            </Column>
        </Row>
        </>

    return (
            <div>
                {mainContent}                      
            </div>
    );
}

export default SliderEmailDocument